var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNtfyOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.754022,
      InkscapeStroke: "none"
    },
    d: "M59.292 93.677c-3.58 0-6.647 2.817-6.647 6.398v.003l.035 27.867-.9 6.635 12.227-3.248H94.4c3.58 0 6.646-2.82 6.646-6.402v-24.855c0-3.58-3.065-6.396-6.643-6.398H94.4zm0 4.516h35.112c1.257.002 2.127.917 2.127 1.882v24.855c0 .966-.871 1.882-2.13 1.882H63.344l-6.211 1.877.063-.366-.034-28.248c0-.966.87-1.882 2.13-1.882z",
    transform: "translate(-51.452 -87.327)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "8.48274px",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.525121
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M62.57 116.77v-1.312l3.28-1.459q.159-.068.306-.102.158-.045.283-.068l.271-.022v-.09q-.136-.012-.271-.046-.125-.023-.283-.057-.147-.045-.306-.113l-3.28-1.459v-1.323l5.068 2.319v1.413z",
    transform: "matrix(2.14521 0 0 2.55031 -122.7 -265.715)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M62.309 110.31v1.903l3.437 1.53.022.007-.022.008-3.437 1.53v1.892l.37-.17 5.221-2.39v-1.75zm.525.817 4.541 2.08v1.076l-4.541 2.078v-.732l3.12-1.389.003-.002a1.56 1.56 0 0 1 .258-.086h.006l.008-.002c.094-.027.176-.047.246-.06l.498-.041v-.574l-.24-.02a1.411 1.411 0 0 1-.231-.04l-.008-.001-.008-.002a9.077 9.077 0 0 1-.263-.053 2.781 2.781 0 0 1-.266-.097l-.004-.002-3.119-1.39z",
    transform: "matrix(2.14521 0 0 2.55031 -122.7 -265.715)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "8.48274px",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.525121
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M69.171 117.754h5.43v1.278h-5.43Z",
    transform: "matrix(2.13886 0 0 2.45586 -121.197 -258.267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#777",
      fillOpacity: 1,
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M68.908 117.492v1.802h5.955v-1.802zm.526.524h4.904v.754h-4.904z",
    transform: "matrix(2.13886 0 0 2.45586 -121.197 -258.267)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtfyOutline);
export default __webpack_public_path__ + "static/media/ntfy-outline.d67fbddc3e59216ce3140fc3330089e6.svg";
export { ForwardRef as ReactComponent };